import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '..';

export type TriageRowActionsProps = {
    showTake?: boolean;
    showModify?: boolean;
    showResolve?: boolean;
    showDiscard?: boolean;
    showRestore?: boolean;
    showMerge?: boolean;
    showMarkSafe?: boolean;
    showTrustSender?: boolean;
    showTrustDomain?: boolean;
    trustSenderTitle?: string;
    trustDomainTitle?: string;
    onTake?: () => void;
    onModify?: () => void;
    onResolve?: () => void;
    onDiscard?: () => void;
    onRestore?: () => void;
    onMerge?: () => void;
    onMarkSafe?: () => void;
    onTrustSender?: () => void;
    onTrustDomain?: () => void;
};

function TriageRowActions(props: TriageRowActionsProps) {
    const {
        showTake, showModify, showResolve, showDiscard, showRestore, showMerge, showMarkSafe,
        showTrustSender, showTrustDomain, trustSenderTitle, trustDomainTitle,
        onTake, onModify, onResolve, onDiscard, onRestore, onMerge, onMarkSafe,
        onTrustSender, onTrustDomain,
    } = props;
    const { t } = useTranslation();

    const hasSecondaryActions = showModify || showResolve || showDiscard || showRestore
        || showMerge || showMarkSafe || showTrustSender || showTrustDomain;

    return (
        <div className="flex items-center justify-end gap-1">
            {hasSecondaryActions && (
                <div className="inline-flex items-center gap-1">
                    {showMarkSafe && (
                        <Button
                            title={t('priorities.mark_safe') as string}
                            icon="thumbs-up"
                            small
                            color="success"
                            onClick={onMarkSafe}
                        />
                    )}
                    {showTrustSender && (
                        <span title={trustSenderTitle || (t('priorities.trust_sender') as string)}>
                            <Button
                                title={t('priorities.trust_sender') as string}
                                icon="email"
                                small
                                color="primary"
                                onClick={onTrustSender}
                            />
                        </span>
                    )}
                    {showTrustDomain && (
                        <span title={trustDomainTitle || (t('priorities.trust_domain') as string)}>
                            <Button
                                title={t('priorities.trust_domain') as string}
                                icon="globe"
                                small
                                color="primary"
                                onClick={onTrustDomain}
                            />
                        </span>
                    )}
                    {showModify && (
                        <Button
                            title={t('priorities.modify') as string}
                            icon="edit"
                            small
                            color="primary"
                            onClick={onModify}
                        />
                    )}
                    {showResolve && (
                        <Button
                            title={t('priorities.resolve') as string}
                            icon="check"
                            small
                            color="success"
                            onClick={onResolve}
                        />
                    )}
                    {showDiscard && (
                        <Button
                            title={t('priorities.discard') as string}
                            icon="delete"
                            small
                            color="danger"
                            onClick={onDiscard}
                        />
                    )}
                    {showRestore && (
                        <Button
                            title={t('priorities.restore') as string}
                            icon="back"
                            small
                            color="primary"
                            onClick={onRestore}
                        />
                    )}
                    {showMerge && (
                        <Button
                            title={t('priorities.merge') as string}
                            icon="merge"
                            small
                            color="primary"
                            onClick={onMerge}
                        />
                    )}
                </div>
            )}
            {hasSecondaryActions && showTake && (
                <span className="mx-0.5 self-stretch border-l border-gray-300 dark:border-gray-600" aria-hidden="true" />
            )}
            {showTake && (
                <Button
                    title={t('priorities.take_card') as string}
                    icon="assigned"
                    small
                    color="primary"
                    onClick={onTake}
                />
            )}
        </div>
    );
}

export default TriageRowActions;
